import React, {useCallback, useContext, useEffect, useReducer, useRef, useState} from 'react';
import {
	Backdrop,
	Button,
	CircularProgress,
	Divider, MenuItem,
	Paper,
	Typography
} from "@mui/material";
import {useHistory, useParams} from "react-router-dom";
import clsx from 'clsx';
import Grid from "@mui/material/Grid";
import {FormProvider, useForm} from "react-hook-form";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from '@mui/material/Alert';
import {setCloseSnackbar, setOpenSnackbar} from "../../../../services/AppServices";
import {generateQuarantenaV4} from "../../../../services/QuaranteneServices";
import {generateIntervistaV2, setIntervista} from "../../../../services/IntervistaServices";
import {getIntervistaApiData, getListaOf} from "../../../../services/utils/IntervistaApiData";
import {initIntervistaState, INTERVISTA_INITIAL_STATE, IntervistaReducer} from "../../../../reducers/IntervistaReducer";
import {initQuaranteneState, QUARANTENE_INITIAL_STATE, QuaranteneReducer} from "../../../../reducers/QuaranteneReducer";
import {AnagraficaContext, AppContext} from "../../../../App";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {ContattaciStyle} from "../../../../styles/pages/contact/ContattaciStyle";
import {sintomi, tipologieQuarantena, tipoMonitortaggio} from "../../../../utils/arrays/Generics";
import {bigNoteRegisterNotRequired} from "../../../../utils/RegisterUtils";
import {SegnalazionePositivoGrid} from "../../../contattaci/intervista/SegnalazionePositivoGrid";
import CustomMultiText from "../../../widgets/inputs/CustomMultiText";
import Copyright from "../../../auth/utils/Copyright";
import HideAppBar from "../../../widgets/header/HideAppBar";
import {AnagraficaCompleta} from "../../../widgets/common/AnagraficaCompleta";
import {addAnagrafica} from "../../../../services/TicketServices";
import {RadioGroupQuestion} from "../../../widgets/inputs/RadioGroupQuestion";
import SearchPaper from "../../paziente/utils/SearchPaper";
import SearchCardResult from "../../paziente/utils/SearchCardResult";
import useAnagraficaSearch from "../../paziente/utils/useAnagraficaSearch";
import {searchAnagrafica} from "../../../../services/AnagraficaServices";
import {clean} from "../../../../utils/GenericUtils";
import {resetAnagrafica} from "./utils/ResetUtils";
import CustomSelect from "../../../widgets/inputs/CustomSelect";


const IntervistaTamponeContatto = () => {
	const contattaciClasses = ContattaciStyle();
	const classes = BaseStyle();
	let history = useHistory();
	const methods = useForm({
		mode: "onChange",
	});
	const anagraficaContext = useContext(AnagraficaContext);
	const [pageNumber, setPageNumber] = useState(0);
	const [value, setValue] = useState("");
	const [open, setOpen] = useState(true);
	
	const [idSoggetto, setIdSoggetto] = useState("");
	const [submit, setSubmit] = useState(false);
	const [submitQuarantena, setSubmitQuarantena] = useState(false);
	const appContext = useContext(AppContext);
	const [intervistaState, intervistaDispatch] = useReducer(IntervistaReducer, INTERVISTA_INITIAL_STATE, initIntervistaState);
	const [quarantenaState, quarantenaDispatch] = useReducer(QuaranteneReducer, QUARANTENE_INITIAL_STATE, initQuaranteneState);
	let {idFocolaio} = useParams();
	const {loadingSearch, errorSearch, anagraficheSearch, hasMoreSearch} = useAnagraficaSearch(value, pageNumber, false);
	const observer = useRef();
	
	const lastTicketElementRef = useCallback(node => {
		if (loadingSearch) return
		if (observer.current) observer.current.disconnect()
		observer.current = new IntersectionObserver(entries => {
			if (entries[0].isIntersecting && hasMoreSearch) {
				setPageNumber(prevState => prevState + 1);
			}
		})
		if (node) observer.current.observe(node)
	}, [loadingSearch, hasMoreSearch])
	
	const handleSearch = (event) => {
		setValue(event.target.value);
	}
	
	const onSearch = useCallback(() => {
		if (open) {
			let data = methods.getValues()?.["search"]
			searchAnagrafica(clean(data), anagraficaContext.dispatch);
		}
	}, [methods, open, anagraficaContext.dispatch])
	
	const handleCloseSnack = useCallback(() => {
		setCloseSnackbar(appContext.dispatch);
	}, [appContext.dispatch]);
	
	const onSubmit = useCallback((data) => {
		console.log(data);
		setIntervista(data, intervistaDispatch)
		addAnagrafica(data.soggetto, (id) => {
			setIdSoggetto(id);
			setSubmit(true);
			generateIntervistaV2({
				...getIntervistaApiData(data),
				tipoContatto: data.tipoContatto,
				soggetto: {...data.soggetto, idSoggetto: id},
				type: "OPR"
			}, intervistaDispatch, true)
		}).then(() => {
			setSubmit(true);
		})
	}, [intervistaDispatch])
	
	const onClickDetail = (anagrafica) => {
		methods.reset({soggetto: resetAnagrafica(anagrafica)});
		document.getElementById("anagrafica-grid-codf").scrollIntoView({behavior: 'smooth', block: 'center'});
	}
	
	useEffect(() => {
		setPageNumber(0);
	}, [value])
	
	useEffect(() => {
		if (submit && !intervistaState.loadingAddIntervista && intervistaState.errorAddIntervista === "") {
			setSubmit(false);
			setSubmitQuarantena(true);
			let score = Math.round(getListaOf(sintomi, intervistaState.intervista)?.split(",")?.length * 4 / 11)
			// se le cose si mettono male commento la v4 e rimetto la v3  :)
			//generateQuarantenaV3(idSoggetto, methods.getValues(), intervistaState.intervista.id, score, "CON_COV", null, quarantenaDispatch, idFocolaio);
			generateQuarantenaV4(
				{idSoggetto: idSoggetto},
				{
					...intervistaState.intervista,
					...methods.getValues(),
					tipoPaziente: "CON_CONV",
					tipo: tipologieQuarantena[1],
					tipoMonitoraggio: tipoMonitortaggio[0],
					score: score,
				},
				intervistaState.intervista.id,
				idFocolaio,
				quarantenaDispatch,
			)
		} else if (submit && !intervistaState.loadingAddIntervista && intervistaState.errorAddIntervista !== "") {
			setSubmit(false);
			setOpenSnackbar("error", intervistaState.errorAddIntervista, appContext.dispatch);
		}
	}, [submit, intervistaState.loadingAddIntervista, intervistaState.errorAddIntervista, idFocolaio, idSoggetto,
		quarantenaDispatch, intervistaState.intervista, appContext.dispatch, methods])
	
	useEffect(() => {
		if (submitQuarantena && !quarantenaState.loadingGenerateQuarantena && quarantenaState.errorGenerateQuarantena === "") {
			setOpenSnackbar("success", "Ordinanza creata correttamente! Tra 2 secondi verrai rimandato indietro", appContext.dispatch);
			setTimeout(() => {
				history.goBack();
			}, 2000)
		} else if (submitQuarantena && !quarantenaState.loadingGenerateQuarantena && quarantenaState.errorGenerateQuarantena !== "") {
			setSubmitQuarantena(false);
			setOpenSnackbar("error", quarantenaState.errorGenerateQuarantena, appContext.dispatch);
		}
	}, [submitQuarantena, quarantenaState.loadingGenerateQuarantena, quarantenaState.errorGenerateQuarantena, appContext.dispatch, history])
	
	useEffect(() => {
		setCloseSnackbar(appContext.dispatch);
	}, [appContext.dispatch])
	
	useEffect(() => {
		document.body.style = `background-image: none`;
	}, []);
	
	return (
		<React.Fragment>
			<Backdrop open={submit} className={classes.backdrop}>
				<CircularProgress color={"inherit"}/>
			</Backdrop>
			<Backdrop open={submitQuarantena} className={classes.backdrop}>
				<CircularProgress color={"inherit"}/>
			</Backdrop>
			<main className={classes.main}>
				<HideAppBar title={"Intervista epidemiologica"} back={true}/>
				
				<article className={contattaciClasses.article}>
					<Paper
						className={clsx(classes.roundBorder, contattaciClasses.mdWidth, classes.transparent80, classes.blurred20)}>
						<form onSubmit={methods.handleSubmit(onSubmit)}>
							<FormProvider {...methods}>
								<Grid container spacing={3}>
									<Grid item xs={12}>
										<Typography color={"primary"} align={"center"} variant={"h4"}>
											<b>Contatto</b>
										</Typography>
										<Typography color={"textSecondary"}>
											Clicca sul bottone dettaglio paziente per andare a visualizzare tutte le informazioni del paziente
											in oggetto (diario, ticket, interviste, quarantene o isolamenti, tamponi, prenotazioni tamponi,
											vaccini, ...) e / o per aggiornare la sua anagrafica.
										</Typography>
									</Grid>
									<Grid item xs={12}>
										<Divider/>
									</Grid>
									
									<SearchPaper value={value} open={open} onSearch={onSearch} handleSearch={handleSearch}
									             setOpen={setOpen}/>
									
									<Grid item xs={12}>
										<SearchCardResult open={open} onClickDetail={onClickDetail} anagraficheSearch={anagraficheSearch}
										                  errorSearch={errorSearch} loadingSearch={loadingSearch}
										                  lastTicketElementRef={lastTicketElementRef}/>
									</Grid>
									
									<AnagraficaCompleta name={"soggetto."}
									                    intro={"false"} moreInfo={true} classes={classes} domReq={true}/>
									<Grid item xs={12}>
										<Divider/>
									</Grid>
									
									<Grid item xs={12}>
										<CustomSelect
											name={"tipoContatto"}
											label={"Tipo di contatto"}
											defaultValue={"Contatto convivente"}
											autoFocus={false}
											rules={{required: true}}
											error={methods.errors["tipoContatto"]}
											control={methods.control}
										>
											<MenuItem value={"Contatto convivente"}>Contatto convivente</MenuItem>
											<MenuItem value={"Contatto stretto"}>Contatto stretto o NON convivente</MenuItem>
										</CustomSelect>
									</Grid>
									<SegnalazionePositivoGrid showAlert={false} isCompagni={false}/>
									<Grid item xs={12}>
										<RadioGroupQuestion
											question={"Vuole effettuare il tampone tramite l'Asl Città di Torino?"}
											control={methods.control}
											autoFocus={true}
											defaultValue={""}
											rules={{required: true}}
											name={"protocollo"}
											error={methods.errors["protocollo"]}
										/>
										<Typography color={"textSecondary"}>
											In caso lei decida di effettuare il tampone per conto suo verrà
											solamente monitorato per quelli
											che sono i suoi sintomi giornalieri; nel caso lei decida di effettuare il tampone tramite l'Asl le
											verrà prenotato un tampone di controllo al 10° o 7° giorno (a seconda della tua situazione vaccini
											/ guarigioni) e verrà contattato il giorno prima.
										</Typography>
									</Grid>
									
									<Grid item xs={12}>
										<CustomMultiText
											inputRef={methods.register(bigNoteRegisterNotRequired)}
											name={"noteQuarantena"}
											label={"Note particolari da indicare"}
											autoFocus={false}
											error={methods.errors["noteQuarantena"]}
											rows={10}
										/>
									</Grid>
									
									<Grid item xs={12} style={{display: "flex", justifyContent: "center"}}>
										<Button variant={"contained"} color={"primary"} disableElevation className={classes.roundButton}
										        onClick={methods.handleSubmit(onSubmit)} disabled={submit}
										        style={{fontSize: 18, borderRadius: 24}}>
											<b>Compila intervista</b>
										</Button>
									</Grid>
								
								</Grid>
							</FormProvider>
						</form>
					</Paper>
				</article>
				<footer style={{marginTop: "8%", display: "flex", flexDirection: "column"}}>
					<Copyright/>
				</footer>
			</main>
			<Snackbar open={appContext.state.open} autoHideDuration={3000} onClose={handleCloseSnack}>
				<SnackAlert style={{borderRadius: 28}} onClose={handleCloseSnack}
				            severity={appContext.state.severity}>
					{appContext.state.message}
				</SnackAlert>
			</Snackbar>
		</React.Fragment>
	);
};

function SnackAlert(props) {
	return <MuiAlert elevation={16} variant="filled" {...props} />;
}

export default React.memo(IntervistaTamponeContatto);
